import { AddPolicyModalComponent } from '../../manual/components/add-policy-modal/add-policy-modal.component';
import { DeletePolicyModalComponent } from '../../manual/components/delete-policy-modal/delete-policy-modal.component';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ICON } from '@core/util/icon';
import {
	TitleInsurancePolicy,
	titleInsurancePolicyTypeString,
} from '@models/title-insurance';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Select } from '@ngxs/store';
import { MatterDispatch } from '@state/matter';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { Observable } from 'rxjs';
import { filter, map, take, withLatestFrom } from 'rxjs/operators';
import { TestHooks } from './title-insurance-policies.hooks';

@UntilDestroy()
@Component({
	selector: 'app-title-insurance-policies',
	templateUrl: './title-insurance-policies.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class TitleInsurancePoliciesComponent {
	testHooks = TestHooks;
	public ICON = ICON;
	titleInsurancePolicyTypeString = titleInsurancePolicyTypeString;

	@Input() disabled = false;
	@Input() type: 'full' | 'compact' = 'compact';

	@SelectSnapshot(SelectedMatter.id) matterId: string;
	@Select(SelectedMatter.titleInsurancePolicies) policies$: Observable<
		TitleInsurancePolicy[]
	>;

	constructor(
		private dialog: MatDialog,
		private matterDispatch: MatterDispatch,
	) {}

	addPolicy(policy?: TitleInsurancePolicy): void {
		this.dialog
			.open(AddPolicyModalComponent, {
				data: {
					policy,
				},
				width: '600px',
				maxWidth: '90vw',
			})
			.afterClosed()
			.pipe(
				untilDestroyed(this),
				take(1),
				filter((result) => !!result), // ensure we have a value returning
				map((result) => result as TitleInsurancePolicy), // just to coerce
				withLatestFrom(this.policies$),
			)
			.subscribe(([result, policies]) => {
				const newPolicies =
					policies?.map((x) => (x.id === policy?.id ? result : x)) || [];
				if (!policy) {
					newPolicies.push(result);
				}
				this.matterDispatch.SetTitleInsurance(this.matterId, {
					policies: newPolicies,
				});
			});
	}

	deletePolicy(id: string): void {
		this.dialog
			.open(DeletePolicyModalComponent, {
				width: '500px',
				maxWidth: '90vw',
			})
			.afterClosed()
			.pipe(
				untilDestroyed(this),
				take(1),
				filter((result) => !!result),
				withLatestFrom(this.policies$),
			)
			.subscribe(([, policies]) => {
				const newPolicies = policies.filter((p) => p.id !== id);
				this.matterDispatch.SetTitleInsurance(this.matterId, {
					policies: newPolicies,
				});
			});
	}
}
